import NavMenu from '../views/pages/Shared/NavMenu.vue';
import InventoryPageItems from '../views/pages/Inventory/InventoryPageItems.vue';
import InventoryPagePresets from '../views/pages/Inventory/InventoryPagePresets.vue';
import InventoryPageAttributes from '../views/pages/Inventory/InventoryPageAttributes.vue';
import InventoryPageAttributesWithType from '../views/pages/Inventory/InventoryPageAttributesWithType.vue';
import InventoryPageHolders from '../views/pages/Inventory/InventoryPageHolders.vue';
import InventoryItemPanel from '../views/pages/Inventory/InventoryItemPanel.vue';

import vueStore from '../store.js';

/**
 * Охрана маршрутов модуля по праву просмотра.
 *
 * По праву, а не по роли: читать раздел может не только менеджер, но и наблюдатель,
 * а в 6.3-B2 — участник городской группы. Проверка роли отсекла бы их всех, хотя бэкенд
 * их пускает, и раздел оказался бы недоступен тем, кому его выдали.
 *
 * На уровне маршрута, а не в глобальном router.beforeEach: тот общий для всего приложения
 * и занят загрузкой Vuex — вплетать туда права одного модуля значит рисковать навигацией
 * везде. К моменту beforeEnter справочники уже в store: глобальный хук вызывает next()
 * только после bootVuex().
 *
 * Прятать пункт меню без этой проверки бессмысленно: адрес /inventory/items открывался бы
 * по прямой ссылке, и пользователь без прав видел бы пустую страницу с 403 в модалке.
 */
function requireInventoryView(to, from, next) {
    const permissions = vueStore.state.workspace.inventoryPermissions;

    // Сравнение с true, а не проверка на истинность: отсутствие справочника означает
    // «нельзя», а не «можно». Источником безопасности остаётся бэкенд.
    if (permissions && permissions.view === true) {
        return next();
    }

    // Уводим на стартовый раздел, а не показываем ошибку: для пользователя без прав этого
    // раздела просто не существует, и он попал сюда по чужой ссылке или из закладки.
    next({ path: '/request/inbox' });
}

export default [
    {
        // Этот путь напечатан на физических наклейках: QR-код каждой единицы техники
        // ведёт на /inventory/items/<id>/card (см. InventoryItemService::generateQRCode()).
        // Переклеить наклейки нельзя, поэтому адрес остаётся навсегда и просто
        // перенаправляет на карточку в панели. Хвост ?item=&_view=&_ticket= из ссылки
        // не читает никто, терять при переходе нечего.
        name: 'inventory.items.card',
        path: '/inventory/items/:item/card',
        redirect: (to) => ({ name: 'inventory.items', params: { id: to.params.item } }),
    },
    {
        // :id? — карточка открывается боковой панелью рядом со списком, а не модалкой:
        // список остаётся виден и не перемонтируется, потому что маршрут тот же. Имя параметра
        // именно id: App.vue по нему прячет список на узком экране, общее для всего приложения.
        name: 'inventory.items',
        path: '/inventory/items/:id?',
        components: {
            menu: NavMenu,
            default: InventoryPageItems,
            sharedPanel: InventoryItemPanel,
        },
        beforeEnter: requireInventoryView,
    },
    {
        name: 'inventory.attributes',
        path: '/inventory/attributes',
        components: {
            menu: NavMenu,
            default: InventoryPageAttributes,
        },
        beforeEnter: requireInventoryView,
    },
    {
        name: 'inventory.attributes.type',
        path: '/inventory/attributes/:type',
        components: {
            menu: NavMenu,
            default: InventoryPageAttributesWithType,
        },
        beforeEnter: requireInventoryView,
    },
    {
        name: 'inventory.presets',
        path: '/inventory/presets',
        components: {
            menu: NavMenu,
            default: InventoryPagePresets,
        },
        beforeEnter: requireInventoryView,
    },
    {
        name: 'inventory.holders',
        path: '/inventory/holders',
        components: {
            menu: NavMenu,
            default: InventoryPageHolders,
        },
        beforeEnter: requireInventoryView,
    },
];
